'use client';

import { IconButton } from '@chakra-ui/react';
import { Crosshair } from 'lucide-react';

export function PreviewInspectorButton({
  enabled,
  ready,
  error,
  onToggle,
}: {
  enabled: boolean;
  ready: boolean;
  error?: string | null;
  onToggle: () => void;
}) {
  return (
    <IconButton
      aria-label={enabled ? 'Stop inspecting elements' : 'Inspect an element'}
      title={
        error
          ? error
          : !ready
            ? 'Inspector is connecting'
            : enabled
              ? 'Stop inspecting'
              : 'Inspect an element for Attune'
      }
      aria-pressed={enabled}
      size="sm"
      variant={enabled ? 'solid' : 'ghost'}
      colorPalette={enabled ? 'blue' : undefined}
      onClick={onToggle}
      disabled={!ready}
    >
      <Crosshair size={15} aria-hidden="true" />
    </IconButton>
  );
}
